import "./_info.scss";

document.addEventListener("click", (event) => {
  const button = event.target.closest(".block__info .btn-copy");
  if (!button) {
    return;
  }

  const value = button.dataset.copyValue;
  if (!value || !navigator.clipboard) {
    return;
  }

  navigator.clipboard.writeText(value).then(() => {
    const label = button.querySelector("span");
    if (!label) {
      return;
    }
    const original = label.textContent;
    label.textContent = "Copiato!";
    setTimeout(() => {
      label.textContent = original;
    }, 1500);
  });
});
